import React from "react";
import { COLORS, CONSULTING_CTA, PERSONAL } from "../data/profile";
import { useLang, t } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";

export default function WhatIDo() {
  const { lang } = useLang();

  const capabilities = [
    {
      title: { en: "Interim Leadership", fr: "Direction par Intérim" },
      text: { en: "COO/Director-level roles, 2–5 days/week. I embed, execute, and deliver.", fr: "Rôles COO/Directeur, 2–5 jours/semaine. Je m'intègre, j'exécute et je livre." },
    },
    {
      title: { en: "AI Implementation", fr: "Implémentation IA" },
      text: { en: "From strategy to deployment at national scale. Not slides — working systems.", fr: "De la stratégie au déploiement à l'échelle nationale. Pas des slides — des systèmes fonctionnels." },
    },
    {
      title: { en: "Europe–Africa Bridge", fr: "Pont Europe–Afrique" },
      text: { en: "Multi-market expansion, government partnerships, complex project delivery.", fr: "Expansion multi-marchés, partenariats gouvernementaux, pilotage de projets complexes." },
    },
  ];

  return (
    <section className="whatido-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading section-heading--light">
            {t(CONSULTING_CTA.title, lang)}
          </h2>
        </ScrollReveal>

        <div className="capability-cards">
          {capabilities.map((cap, i) => (
            <ScrollReveal key={i} delay={i * 120}>
              <div className="capability-card">
                <h3 className="capability-title">{t(cap.title, lang)}</h3>
                <p className="capability-text">{t(cap.text, lang)}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={400}>
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <a href="https://calendly.com/chris-kohlerholding/30min" className="cta-button" target="_blank" rel="noopener noreferrer">
              {lang === "en" ? "Book a Call" : "Réserver un Appel"}
            </a>
            <div className="cta-secondary">
              {lang === "en" ? "or " : "ou "}
              <a href={`mailto:${PERSONAL.email}`}>
                {lang === "en" ? "email me" : "envoyez-moi un email"}
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
